<mat-chip-grid #chipList>

    <mat-chip-row *ngFor="let chip of selectedItems"
              [removable]="true"
              [disableRipple]="true"
              (removed)="removeChip(chip, trigger)">
        {{ chip[dataLabelAttribute] || chip[dataIdentAttribute] }}
        <ng-container *ngIf="hasRemove">
            <mat-icon matChipRemove>cancel</mat-icon>
        </ng-container>
    </mat-chip-row>

    <div fxFlex=100>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <input #input
                   #trigger="matAutocompleteTrigger"
                   matInput
                   [formControl]="itemCtrl"
                   [matChipInputFor]="chipList"
                   [matChipInputAddOnBlur]="true"
                   [placeholder]="placeholder"
                   [errorStateMatcher]="errorStateMatcher"
                   [matAutocomplete]="matAutocomplete ? matAutocomplete : null"
                   [matAutocompleteDisabled]="!filteredItems"
                   (matChipInputTokenEnd)="addChip($event, input)"
                   data-test="FI-Chips"/>

            <button mat-icon-button matIconSuffix matTooltip="Eingabefeld zurücksetzen" *ngIf="!!itemCtrl.value"
                    (mousedown)="clearInput($event)">
                <mat-icon>backspace</mat-icon>
            </button>
        </div>
    </div>

    <mat-autocomplete [hidden]="!filteredItems"
                      #chipListAutocomplete="matAutocomplete"
                      fxFlex="100"
                      [displayWith]="displayWith"
                      (optionSelected)="selected($event)">
        <ng-container *ngIf="currentFilteredItems?.length">
            <mat-option class="sticky-option" disabled>
                <!-- Everything stays inside this wrapper: a <mat-icon> placed directly in the option
                     is projected into MatOption's own `select="mat-icon"` slot, which renders it
                     outside the label span and breaks this row's layout. -->
                <div class="sticky-option-content">
                    <ng-container *ngIf="currentFilteredItems.length !== _allItems.length">
                        <div (mousedown)="$event.stopPropagation(); addAllFromFilteredList()">
                            <mat-icon>playlist_add</mat-icon>
                            Auswahl hinzufügen
                        </div>
                    </ng-container>
                    <ng-container *ngIf="currentFilteredItems.length === _allItems.length">
                        <div class="flex-placeholder"></div>
                    </ng-container>
                    <button type="button"
                            mat-icon-button
                            class="sticky-option-close"
                            [attr.aria-label]="'common.close' | translate"
                            (mousedown)="closeAutocompletePanel($event)">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </mat-option>
        </ng-container>
        <ng-container *ngFor="let item of filteredItems | async">
            <mat-option [value]="item"
                        [disabled]="item.disabled"
                        [matTooltip]="item.disabledReason"
                        [matTooltipDisabled]="!item.disabled || !item.disabledReason"
                        (click)="trigger.openPanel()">
                {{ item[dataLabelAttribute] || item[dataIdentAttribute] }}
            </mat-option>
        </ng-container>

        <mat-option *ngIf="(filteredItems | async)?.length === 0" disabled>
            Keine Einträge gefunden
        </mat-option>
    </mat-autocomplete>

</mat-chip-grid>
